var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineHeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 966 829.9",
    style: {
      enableBackground: "new 0 0 966 829.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M921.9,203c16.8,4.2,29,2.4,36.5-5.4c7.8-8.3,9.6-20.3,5.4-36L810.6,14.6c-2.8-2.6-5.7-4.9-8.5-6.9 c-13.7-10.1-27.4-10.1-41.1,0c-2.8,2.1-5.7,4.4-8.5,6.9L599.4,161.5c-4.1,15.8-2.3,27.8,5.4,36c7.2,7.8,19.4,9.6,36.4,5.4 L754,93.7v641.2L641.2,625.6c-17-4.1-29.2-2.3-36.4,5.5c-7.8,8.3-9.6,20.3-5.4,36L752.5,814c10.1,9.6,19.6,14.9,28.7,15.9 c9-1,18.8-6.3,29.4-15.9l153.2-146.9c4.1-15.8,2.3-27.8-5.4-36c-7.5-7.8-19.7-9.6-36.5-5.5L809.1,734.9V93.7L921.9,203 M0,685.7 v75.6h488.5v-75.6H0 M488.5,458.1v-75.6H0v75.6H488.5 M488.5,154.5V78.9H0v75.6H488.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineHeightIcon);
export default __webpack_public_path__ + "static/media/line_height_icon.07af93ea.svg";
export { ForwardRef as ReactComponent };